<template>
  <Header />
  <SideBar />
  <main id="main-content" class="ml-64 p-8">
    <div id="page-header" class="mb-8">
      <div class="flex items-center justify-between">
        <div>
          <h2 class="text-2xl font-bold text-green-800">User Managment</h2>
          <p class="mt-2 text-gray-600 text-sm">All users for your organization are found here</p>
        </div>
        <button id="create-key-btn"
          class="bg-green-800 hover:bg-green-700 text-white px-4 py-3
          rounded-md flex items-center
          space-x-2 font-medium text-white bg-gradient-to-r from-green-700
          to-green-800 hover:from-green-700 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 transform hover:scale-[1.02]"
          @click="showModal = true">
          <i class="fa-solid fa-user-plus mr-1"></i>
          <span>New User</span>
        </button>
        <Modal :show="showModal" title="Create new user" size="max-w-4xl" @close="showModal =
          true">
          <div v-if="loading" class="flex justify-center items-center h-32">
            <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-green-600"></div>
          </div>
          <div id="error" class="mt-4 bg-red-100 border border-red-100 rounded-md p-6 mb-4" v-if="error.length > 0">
            <div class="flex items-start">
              <p>{{ error }}</p>
            </div>
          </div>
          <form class="space-y-6" @submit.prevent="registerUser()" v-if="!loading">
            <div class="space-y-2 mb-6">
              <label class="block text-sm font-medium text-gray-600">First Name</label>
              <div class="relative">
                <input type="text" id="text" name="text" class="block w-full pl-5 pr-3 py-3
                  bg-white/10 border border-gray-500/20 rounded-sm
              border-gray-300
              text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2
                  focus:ring-green-500 focus:border-transparent" placeholder="John / Jane" v-model="firstName"
                  required />
                <p class="text-gray-500 text-sm">First name for the new user</p>
              </div>
            </div>
            <div class="space-y-2 mb-2">
              <label class="block text-sm font-medium text-gray-600">Last Name</label>
              <div class="relative">
                <input type="text" id="text" name="text" class="block w-full pl-5 pr-3 py-3
                  bg-white/10 border border-gray-500/20 rounded-sm
              border-gray-300
              text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2
                  focus:ring-green-500 focus:border-transparent" placeholder="Doe" v-model="lastName" required />
                <p class="text-gray-500 text-sm">Last name for the new user</p>
              </div>
            </div>
            <div class="space-y-2 mb-2">
              <label class="block text-sm font-medium text-gray-600">Email Address</label>
              <div class="relative">
                <input type="email" id="text" name="text" class="block w-full pl-5 pr-3 py-3
                  bg-white/10 border border-gray-500/20 rounded-sm
              border-gray-300
              text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2
                  focus:ring-green-500 focus:border-transparent" placeholder="jhon@example.com" v-model="emailAddress"
                  required />
                <p class="text-gray-500 text-sm">Email address for the new user.
                  Please note that this is the username</p>
              </div>
            </div>
            <div class="flex justify-end space-x-2 mt-5">
              <slot name="footer">
                <button @click="close()" type="button" class="px-4 py-1 bg-gray-300 rounded-sm hover:bg-gray-400"
                  @close="showModal = true">
                  Close
                </button>
                <button class="bg-green-800 hover:bg-green-700 text-white px-6 py-3
          rounded-md flex items-center
          space-x-2 font-medium text-white bg-gradient-to-r from-green-700
          to-green-800 hover:from-green-700 hover:to-green-700 focus:outline-none focus:ring-2
          focus:ring-offset-2 rounded-lg focus:ring-blue-500 transition-all duration-200 transform hover:scale-[1.02]">
                  Save
                </button>
              </slot>
            </div>
          </form>
        </Modal>
      </div>
    </div>
    <!-- API Keys Table -->
    <div id="users-table" class="bg-white rounded-lg shadow-sm border border-gray-200">
      <div v-if="userStore.loading" class="flex justify-center items-center h-32">
        <lottie-animation path="assets/images/loading.json" :width="150" :height="150" />
      </div>
      <div class="overflow-x-auto" v-if="!userStore.loading">
        <table class="w-full">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase
                tracking-wider">User</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase
                tracking-wider">Status</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase
                tracking-wider">Created</th>
              <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase
                tracking-wider">Action</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr id="user" v-for="user in  userStore.users " :key="user.id">
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                <div class="flex items-center">
                  <div class="h-10 w-10 rounded-full bg-green-800 mr-3 p-3">
                    <i class="fa-solid fa-user text-white items-center"></i>
                  </div>
                  <div>
                    <div class="text-sm font-medium text-gray-900">{{ user.firstName }} {{
                      user.lastName }}</div>
                    <div class="text-sm text-gray-500">{{ user.emailAddress.String }}</div>
                  </div>
                </div>
              </td>
              <td class="px-6 py-4 whitespace-nowrap">
                <span class="px-2 py-1 text-xs font-medium bg-red-100 text-red-800 rounded-full"
                  v-if="user.status === 'NOT_VERIFIED'">Not Verified</span>
                <span class="px-2 py-1 text-xs font-medium bg-green-100 text-green-800 rounded-full"
                  v-if="user.status === 'VERIFIED'">Verified</span>
                <span class="px-2 py-1 text-xs font-medium bg-indigo-100 text-indigo-800
                  rounded-full" v-if="user.status === 'ACTIVE'">Active</span>
                <span class="px-2 py-1 text-xs font-medium bg-yellow-100 text-yellow-800
                  rounded-full" v-if="user.status === 'INACTIVE'">Inactive</span>
              </td>
              <td class=" px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ formatDate(user.createdAt) }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-right text-md font-medium">
                <div class="flex space-x-3">
                  <button @click="handleResetPassword(user.id)" class="text-amber-600 hover:text-amber-800"
                    title="Reset Password">
                    <i class="fa-solid fa-rotate-right"></i>
                  </button>
                  <template v-if="canManageUsers">
                    <button @click="editUser(user)" class="text-green-600 hover:text-green-900" title="Edit User">
                      <i class="fa-solid fa-edit"></i>
                    </button>
                    <button @click="managePermissions(user)" class="text-green-600 hover:text-green-900"
                      title="Manage Permissions">
                      <i class="fa-solid fa-key"></i>
                    </button>
                  </template>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="px-6 py-4 border-t border-gray-200">
          <div class="flex items-center justify-between">
            <div class="text-sm text-gray-700">
              Showing <span class="font-medium">{{ userStore.pagination.currentPage }}</span> of <span
                class="font-medium">{{ userStore.pagination.totalPages }}</span> results
            </div>
            <div class="flex items-center space-x-2" v-if="userStore.pagination.nextPage > 0">
              <button class="px-3 py-1 border border-gray-300 rounded text-sm text-gray-500 hover:bg-gray-50"
                disabled>Previous</button>
              <button class="px-3 py-1 bg-blue-600 text-white rounded text-sm">{{
                userStore.pagination.nextPage }}</button>
              <button
                class="px-3 py-1 border border-gray-300 rounded text-sm text-gray-700 hover:bg-gray-50">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Update User Modal -->
    <UpdateUserModal :show="showEditModal" :user="selectedUser" @close="showEditModal = false"
      @userUpdated="handleUserUpdated" />

    <!-- Assign Permission Modal -->
    <AssignPermissionModal :show="showPermissionModal" :user="selectedUser" @close="showPermissionModal = false"
      @permissionsUpdated="handlePermissionsUpdated" />
  </main>
</template>
<script setup lang="ts">
import { onMounted, ref, computed } from 'vue';
import { useUserStore } from '@/store/users';
import { useNotificationStore } from '@/store/notifications';
import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue';
import Header from '../components/header.vue';
import SideBar from '../components/sidebar.vue';
import Modal from '../components/modal.vue';
import UpdateUserModal from '../components/UpdateUserModal.vue';
import AssignPermissionModal from '../components/AssignPermissionModal.vue';

const userStore = useUserStore();
const notificationStore = useNotificationStore();
const showModal = ref<boolean>(false);
const showEditModal = ref<boolean>(false);
const showPermissionModal = ref<boolean>(false);
const selectedUser = ref<any>(null);
const firstName = ref('');
const lastName = ref('');
const emailAddress = ref('');
const error = ref<string>('');
const loading = ref<boolean>(false);

const canManageUsers = computed(() => {
  const purpose = localStorage.getItem('purpose');
  if (purpose === 'local') return true;

  const permissions = localStorage.getItem('permissions');
  if (!permissions) return false;
  const permissionList = permissions.split(',').map((p) => p.trim().toLowerCase());
  return permissionList.includes('manage_users');
});

onMounted(() => {
  const purpose = localStorage.getItem('purpose');

  if (purpose === 'public') {
    userStore.fetchUsers(1);
  } else if (purpose === 'local') {
    userStore.fetchAdminUsers(1);
  }
});

function close() {
  userStore.error = null;
  showModal.value = false;
}

function formatDate(input: string) {
  const date = new Date(input);
  const formatted = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  }).format(date);
  return formatted;
}

async function registerUser() {
  if (firstName.value === '' || lastName.value === '' || emailAddress.value === '') {
    notificationStore.showError('Validation Error', 'Please fill in all required fields.');
    return;
  }

  loading.value = true;
  try {
    const purpose = localStorage.getItem('purpose');

    if (purpose === 'public') {
      await userStore.registerUser(firstName.value, lastName.value, emailAddress.value);
    } else if (purpose === 'local') {
      await userStore.registerAdmin(firstName.value, lastName.value, emailAddress.value);
    }

    if (userStore.error) {
      notificationStore.showError('User Registration Failed', userStore.error);
    } else {
      notificationStore.showSuccess('User Created', 'New user has been registered successfully.');
      showModal.value = false;
      userStore.fetchUsers(1);
      firstName.value = '';
      lastName.value = '';
      emailAddress.value = '';
    }
  } catch (err) {
    notificationStore.showError('Registration Error', 'An unexpected error occurred during user registration.');
  } finally {
    loading.value = false;
  }
}

async function handleResetPassword(userId: string) {
  try {
    await userStore.resetPassword(userId);
    if (userStore.error) {
      notificationStore.showError('Reset Failed', userStore.error);
    } else {
      notificationStore.showSuccess('Password Reset', 'A new password has been sent to the user\'s email.');
    }
  } catch (err) {
    notificationStore.showError('Reset Error', 'An unexpected error occurred.');
  }
}

function editUser(user: any) {
  selectedUser.value = user;
  showEditModal.value = true;
}

function handleUserUpdated() {
  userStore.fetchUsers(1);
}

function managePermissions(user: any) {
  selectedUser.value = user;
  showPermissionModal.value = true;
}

function handlePermissionsUpdated() {
  // Permissions updated, no need to refresh user list
}

</script>
